import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seminar',
  templateUrl: './seminar.component.html',
  styleUrls: ['./seminar.component.scss']
})
export class SeminarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
